import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventCollisionMatch } from 'app/event/models/event-collision-match';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { User } from '../../auth/models/User';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { EventCollisionModalResponse } from './event-collision-modal-response';
import { EventCollisionModalResponseEnum } from './event-collision-modal-response.enum';

@Component({
  selector: 'pioneer-event-collision-modal',
  templateUrl: './event-collision-modal.component.html',
  styleUrls: ['./event-collision-modal.component.css']
})
export class EventCollisionModalComponent implements OnInit {

  public EventCollisionModalResponse = EventCollisionModalResponse;

  @Input()
  public create = 'EVENT_COLLISION.MODAL.SINGLE.CREATE';

  @Input()
  public confirm = 'EVENT_COLLISION.MODAL.SINGLE.CONFIRM';

  @Input()
  public notConfirm = 'EVENT_COLLISION.MODAL.SINGLE.NOT_CONFIRM';

  @Input()
  public cancel = 'EVENT_COLLISION.MODAL.SINGLE.CANCEL';

  @Input()
  public title = 'EVENT_COLLISION.MODAL.SINGLE.TITLE';

  @Input()
  public content = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_TEXT';

  @Input()
  public contentFinal = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_FINAL_TEXT';

  @Input()
  public contentFinalAddVendor = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_FINAL_TEXT_NOT_CONFIRM';

  @Input()
  public heading = 'EVENT_COLLISION.MODAL.SINGLE.HEADING';

  @Input()
  public headingDetails = 'EVENT_COLLISION.MODAL.SINGLE.HEADING_DETAILS';

  @Input()
  public eventMatch: EventCollisionMatch;

  @Input()
  public match: any | null = {};

  @Input()
  public config = {
    backdrop: 'static'
  } as ModalOptions;

  @Input()
  public user: User;

  @Input()
  public mode: string;

  @Output()
  public closed = new EventEmitter();

  @Output()
  public canceled = new EventEmitter();

  @ViewChild(ModalDirective)
  public confirmationModal: ModalDirective;

  response: EventCollisionModalResponse;

  constructor(private authenticationStore: AuthenticationStore) { }

  ngOnInit() {
  }

  get isPropertyUser(): boolean {
    return this.authenticationStore.isPropertyUser();
  }

  get isShown(): boolean { return this.confirmationModal.isShown; }

  public open(eventMatch: EventCollisionMatch, match: any): void {
    this.response = undefined;
    this.eventMatch = eventMatch;
    this.match = match;
    this.confirmationModal.show();
  }

  confirmMatchingEvent() {
    let selectedMatches = [];
    selectedMatches.push(this.eventMatch.eventMatchId);
    this.response = new EventCollisionModalResponse({
      selectedButton: EventCollisionModalResponseEnum.MergeEvents,
      selectedMatches: selectedMatches
    });
    this.confirmationModal.hide();
  }

  createNewEvent() {
    this.response = new EventCollisionModalResponse({
      selectedButton: EventCollisionModalResponseEnum.DoNotMergeEvents,
      selectedMatches: []
    });
    this.confirmationModal.hide();
  }

  cancelEventMatching() {
    this.response = new EventCollisionModalResponse({
      selectedButton: undefined,
      selectedMatches: []
    });
    this.confirmationModal.hide();
  }
  public completePropertyForEventMatched(): string {
    return this.match.property_name + ' ' + this.match.property_address;
  }

  onHide() {
    if (this.response.selectedButton === undefined) {
      this.canceled.emit(this.response);
    } else {
      this.closed.emit(this.response);
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal.component.ts